export const hasValue = (value: any): boolean => {
  return value !== null && value !== undefined;
};
